import React from 'react';
import PropTypes from 'prop-types';

const Mail = ({ width, className }) => (
  <svg
    width={width}
    height={width}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <rect x="2" y="4" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2 5.5L9 10L16 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

Mail.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

Mail.defaultProps = {
  width: 18,
  className: '',
};

export default Mail;
